import {
  addWorkArea,
  selectActiveProjectId,
  selectAllWorkAreasWithStatus,
  useAppDispatch,
  useAppSelector,
} from '@core/core/store'
import type { TokenProps } from 'common/types'
import type { FC } from 'react'
import { useCallback, useEffect, useState } from 'react'

import { WorkArea } from './WorkArea'
import css from './WorkAreas.css'

const WORK_AREAS_LIMIT = 2

type WorkAreasProps = TokenProps

export const WorkAreas: FC<WorkAreasProps> = ({ getToken }) => {
  const dispatch = useAppDispatch()

  const workAreas = useAppSelector(selectAllWorkAreasWithStatus)
  const projectId = useAppSelector(selectActiveProjectId)

  const [isWorkAreaUpdating, setIsWorkAreaUpdating] = useState<boolean>(false)
  const isWorkAreaLimitExceeded = workAreas.length >= WORK_AREAS_LIMIT || isWorkAreaUpdating

  useEffect(() => {
    setIsWorkAreaUpdating(false)
  }, [workAreas])

  const onSplitView = useCallback(() => {
    setIsWorkAreaUpdating(true)
    dispatch(addWorkArea(projectId))
  }, [projectId])

  return (
    <div className={css.container}>
      {workAreas.map(({ id, tabs, isActive, activeTabId }) => (
        <WorkArea
          key={id}
          workAreaId={id}
          activeTabId={activeTabId}
          isWorkAreaActive={isActive}
          tabs={tabs}
          isSplitDisabled={isWorkAreaLimitExceeded}
          getToken={getToken}
          onSplitView={onSplitView}
        />
      ))}
    </div>
  )
}
